import { ExposedDropdown } from 'components/dropdown/ExposedDropdown'
import { useFlags } from 'config/useFlagsContext'
import React from 'react'
import {
  CuidadoCompartilhadoSortEnum,
  ListaCuidadoCompartilhadoFilterModel,
} from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

interface ListaCuidadoCompartilhadoSortDropdownProps {
  items: CuidadoCompartilhadoSortEnum[]
  filter: ListaCuidadoCompartilhadoFilterModel
  onChange(filter: ListaCuidadoCompartilhadoFilterModel): void
}

const LCCSortMap: { [key in CuidadoCompartilhadoSortEnum]: string } = {
  [CuidadoCompartilhadoSortEnum.STATUS_EXECUTANTE]: 'Classificação por status',
  [CuidadoCompartilhadoSortEnum.STATUS_SOLICITANTE]: 'Classificação por status',
  [CuidadoCompartilhadoSortEnum.CLASSIFICACAO_DE_PRIORIDADE_EXECUTANTE]: 'Classificação por prioridade',
  [CuidadoCompartilhadoSortEnum.CLASSIFICACAO_DE_PRIORIDADE_SOLICITANTE]: 'Classificação por prioridade',
}

const LCCSortMapWithFlag: { [key in CuidadoCompartilhadoSortEnum]: string } = {
  [CuidadoCompartilhadoSortEnum.STATUS_EXECUTANTE]: 'Status',
  [CuidadoCompartilhadoSortEnum.STATUS_SOLICITANTE]: 'Status',
  [CuidadoCompartilhadoSortEnum.CLASSIFICACAO_DE_PRIORIDADE_EXECUTANTE]: 'Prioridade',
  [CuidadoCompartilhadoSortEnum.CLASSIFICACAO_DE_PRIORIDADE_SOLICITANTE]: 'Prioridade',
}

export function ListaCuidadoCompartilhadoSortDropdown(props: ListaCuidadoCompartilhadoSortDropdownProps) {
  const { items, filter, onChange } = props

  const { PILOTO_NOTIFICACAO_LOTACAO_ENABLED } = useFlags()

  const onChangeSelect = (sort: CuidadoCompartilhadoSortEnum) => {
    onChange({
      ...filter,
      pageParams: {
        ...filter.pageParams,
        sort,
      },
    })
  }

  return (
    <ExposedDropdown<CuidadoCompartilhadoSortEnum>
      label='Ordenar por:'
      selectedItem={filter.pageParams.sort}
      items={items}
      itemToString={itemToString(PILOTO_NOTIFICACAO_LOTACAO_ENABLED)}
      onChange={onChangeSelect}
    />
  )
}

const itemToString = (flag: boolean) => (sort: CuidadoCompartilhadoSortEnum) =>
  flag ? LCCSortMapWithFlag[sort] : LCCSortMap[sort]
